import { connect } from 'react-redux'
import AdminDashboard from '../index'
import { getAdminDashboardMetrics } from '../actions'
import adminDashboardSelectors from '../selectors'

const mapStateToProps = state => ({
  adminDashboardMetrics: adminDashboardSelectors.getAdminDashboardMetricsData(state),
  loading: state?.adminDashboard?.loading,
})

const mapDispatchToProps = {
  getAdminDashboardMetrics,
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard)
   